import { useMemo } from "react";
import { useReferencePhotos } from "@/hooks/useReferencePhotos";
import { buildPropertyGalleryUrls } from "@/lib/propertyGalleryPhotos";

type PropertyWithPhotos = {
  property_photo_url?: string | null;
  property_photo_urls?: string[] | null;
};

/** Ordered URLs for overview header gallery (DB gallery, then reference-photo fallback). */
export function usePropertyGalleryPhotos(
  propertyId: string | undefined,
  property: PropertyWithPhotos | null | undefined
): string[] {
  const { data: referencePhotosData } = useReferencePhotos(propertyId, null);

  return useMemo(() => {
    const stored = property?.property_photo_urls?.length
      ? property.property_photo_urls.filter(Boolean)
      : property?.property_photo_url
        ? [property.property_photo_url]
        : [];

    if (stored.length > 0) return stored;

    const refUrls = (referencePhotosData?.list ?? []).map((p) => p.photo_url).filter(Boolean);
    return buildPropertyGalleryUrls(property?.property_photo_url, refUrls);
  }, [property, referencePhotosData?.list]);
}
